import { UserEvolutionFilterInterface } from '@contacts/interfaces/user-evolution';

export const filters: UserEvolutionFilterInterface = {
  period: {
    label: 'reports.user_evolution.period.label',
    placeholder: 'reports.user_evolution.period.placeholder',
    options: [
      {
        text: 'reports.user_evolution.period.option.today',
        value: 'today',
      },
      {
        text: 'reports.user_evolution.period.option.yesterday',
        value: 'yesterday',
      },
      {
        text: 'reports.user_evolution.period.option.last_7_days',
        value: 'last_7_days',
      },
      {
        text: 'reports.user_evolution.period.option.last_14_days',
        value: 'last_14_days',
      },
      {
        text: 'reports.user_evolution.period.option.last_month',
        value: 'last_month',
      },
      {
        text: 'reports.user_evolution.period.option.last_trimester',
        value: 'last_trimester',
      },
      {
        text: 'reports.user_evolution.period.option.last_semester',
        value: 'last_semester',
      },
      {
        text: 'reports.user_evolution.period.option.last_year',
        value: 'last_year',
      },
    ],
  },
};

export const grouping = {
  duration: {
    label: 'reports.user_evolution.grouping.label',
    placeholder: 'reports.user_evolution.grouping.placeholder',
    options: [
      {
        text: 'reports.user_evolution.grouping.option.per_hour',
        value: 'per_hour',
      },
      {
        text: 'reports.user_evolution.grouping.option.per_day',
        value: 'per_day',
      },
      {
        text: 'reports.user_evolution.grouping.option.per_week',
        value: 'per_week',
      },
      {
        text: 'reports.user_evolution.grouping.option.per_month',
        value: 'per_month',
      },
    ],
  },
};
